import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const UnreadIcon = (props: IconProps) => (
  <Icon width="17px" height="17px" viewBox="0 0 17 17" {...props}>
    <path d="M13.0321 9.5v2.9333c0 .6234-.51 1.1334-1.1334 1.1334H3.9654l-2.26667 2.2666V5.63333c0-.62333.51-1.13333 1.13333-1.13333h5.44417c-.034.18133-.05667.374-.05667.56667 0 .19266.02267.38533.05667.56666H2.83206v6.79997h9.06664V9.5h1.1334Zm-.0002-1.66667c-1.4756 0-2.6667-1.19111-2.6667-2.66666 0-1.47556 1.1911-2.66667 2.6667-2.66667s2.6667 1.19111 2.6667 2.66667c0 1.47555-1.1911 2.66666-2.6667 2.66666Z" />
  </Icon>
);

export default memo(UnreadIcon);
